/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-return-bill-item.reducer';

export const PharmacyReturnBillItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyReturnBillItemEntity = useAppSelector(state => state.pharmacyReturnBillItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyReturnBillItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillItem.detail.title">PharmacyReturnBillItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillItemEntity.id}</dd>
          <dt>
            <span id="chargedMrp">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillItem.chargedMrp">Charged Mrp</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillItemEntity.chargedMrp}</dd>
          <dt>
            <span id="returnClaimed">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillItem.returnClaimed">Return Claimed</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillItemEntity.returnClaimed}</dd>
          <dt>
            <span id="returnQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillItem.returnQty">Return Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillItemEntity.returnQty}</dd>
          <dt>
            <span id="manufacDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillItem.manufacDate">Manufac Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillItemEntity.manufacDate}</dd>
          <dt>
            <span id="expDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillItem.expDate">Exp Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillItemEntity.expDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillItemEntity.cursor}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillItem.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillItemEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillItemEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillItem.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{pharmacyReturnBillItemEntity.lastUpdated}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillItem.pharmacyStock">Pharmacy Stock</Translate>
          </dt>
          <dd>{pharmacyReturnBillItemEntity.pharmacyStock ? pharmacyReturnBillItemEntity.pharmacyStock.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyReturnBillItem.returnBill">Return Bill</Translate>
          </dt>
          <dd>{pharmacyReturnBillItemEntity.returnBill ? pharmacyReturnBillItemEntity.returnBill.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-return-bill-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-return-bill-item/${pharmacyReturnBillItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyReturnBillItemDetail;
